import { Container, Row, Col } from 'react-bootstrap';
import { CreditCard, Camera, MessageSquare } from 'lucide-react';
import { ArrowRight } from 'react-bootstrap-icons';
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { trackEvent } from "../../../analytics";
import { setFromLandingPage } from "../../../Redux/landingPageSlice";

const HowItWorks = () => {
  const steps = [
    {

      icon: Camera,
      title: "1. List Your Items",
      description: "Take photos and create listings for items you want to rent out. Set your own prices and availability."
    },
    {

      icon: MessageSquare,
      title: "2. Connect with Renters",
      description: "Receive booking requests and communicate with verified renters through our secure messaging system."
    },
    {

      icon: CreditCard,
      title: "3. Get Paid",
      description: "Receive secure payments automatically. Money is transferred to your account within 24 hours of rental completion."
    }
  ];
  const dispatch = useDispatch()


  const handleStartClick = () => {
    dispatch(setFromLandingPage(true))
    trackEvent('User Interaction', 'Open Popup', 'Login Popup');
    document?.getElementById("headerlogin").click();

  }

  return (
    <section id="how-it-works" className="section-padding " style={{
      background: 'var(--color-grey-98, #F9FAFB)'
    }}>
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-4" style={{ color: 'var(--text-dark)', letterSpacing: "-2.4px" }}>
            How It Works
          </h2>
          <p className="text-gray fs-5" >
            Start earning in just 3 simple steps          </p>
        </div>

        <Row className="">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Col md={4} key={index} className="text-center">
                <div className="position-relative mb-4">
                  <div
                    className="rounded-circle d-flex bg-green align-items-center justify-content-center mx-auto shadow-lg card-hover"
                    style={{
                      width: '80px',
                      height: '80px',

                    }}
                  >
                    <Icon size={40} color="white" />
                  </div>

                </div>

                <h3 className="h5 fw-bold mb-3" style={{ color: 'var(--text-dark)' }}>
                  {step.title}
                </h3>
                <p style={{ color: 'var(--text-muted)', lineHeight: '1.6', maxWidth: '300px' }} className="mx-auto">
                  {step.description}
                </p>
              </Col>
            );
          })}
        </Row>
        <div className="d-flex justify-content-center my-4">
          <Button size="lg" onClick={handleStartClick} className="start-lending-btn d-flex align-items-center justify-content-between py-3 px-4" >
            Start Lending Now
            <ArrowRight />
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default HowItWorks;